module.exports = __webpack_public_path__ + "static/media/RealTimeCommunication_web_005.7af6f71e.png";